// @flow
import { all, fork, put, takeEvery, call } from 'redux-saga/effects';
import {
    getInstanceOpinometros as listInstanceOpinometroAPI,
    getInstanceOpinometro as getInstanceOpinometroAPI,
    addInstanceOpinometro as addInstanceOpinometroAPI,
    updateInstanceOpinometro as updateInstanceOpinometroAPI,
    deleteInstanceOpinometro as deleteInstanceOpinometroAPI
} from '../../helpers/';

// import { APICore, setAuthorization } from '../../helpers/api/apiCore';
import { instanceOpinometroApiResponseError, instanceOpinometroApiResponseSuccess } from './actions';
import { InstanceOpinometroActionTypes } from './constants';

// const api = new APICore();

/**
 * Get contacto
 * @param {*} payload - username and password
 */
function* getInstanceOpinometro({ payload: { id } }) {
    try {
        const response = yield call(getInstanceOpinometroAPI, id);
        const instanceOpinometroItem = response.data.data;
        yield put(instanceOpinometroApiResponseSuccess(InstanceOpinometroActionTypes.GET_INSTANCE_OPINOMETRO, instanceOpinometroItem));
    } catch (error) {
        yield put(instanceOpinometroApiResponseError(InstanceOpinometroActionTypes.GET_INSTANCE_OPINOMETRO, error));
    }
}

function* addInstanceOpinometro({ payload: instanceOpinometro }) {
    try {
        const response = yield call(addInstanceOpinometroAPI, { ...instanceOpinometro })
        const instanceOpinometroItem = response.data.data
        yield put(instanceOpinometroApiResponseSuccess(InstanceOpinometroActionTypes.ADD_INSTANCE_OPINOMETRO, instanceOpinometroItem))
    } catch (error) {
        yield put(instanceOpinometroApiResponseError(InstanceOpinometroActionTypes.ADD_INSTANCE_OPINOMETRO, error))
    }
}

function* updateInstanceOpinometro({ payload: instanceOpinometro }) {
    try {
        const response = yield call(updateInstanceOpinometroAPI, { ...instanceOpinometro })
        const instanceOpinometroItem = response.data
        yield put(instanceOpinometroApiResponseSuccess(InstanceOpinometroActionTypes.UPDATE_INSTANCE_OPINOMETRO, instanceOpinometroItem))
    } catch (error) {
        yield put(instanceOpinometroApiResponseError(InstanceOpinometroActionTypes.UPDATE_INSTANCE_OPINOMETRO, error))
    }
}
function* deleteInstanceOpinometro({ payload: { id } }) {
    try {
        const response = yield call(deleteInstanceOpinometroAPI, id)
        const instanceOpinometroItem = response.data.id
        yield put(instanceOpinometroApiResponseSuccess(InstanceOpinometroActionTypes.DELETE_INSTANCE_OPINOMETRO, instanceOpinometroItem))
    } catch (error) {
        yield put(instanceOpinometroApiResponseError(InstanceOpinometroActionTypes.DELETE_INSTANCE_OPINOMETRO, error))
    }
}

/**
 * List contactos
 */
function* listInstanceOpinometro({ payload: params }) {
    try {
        const response = yield call(listInstanceOpinometroAPI, { ...params });
        const listaInstanceOpinometro = response.data.data;
        yield put(instanceOpinometroApiResponseSuccess(InstanceOpinometroActionTypes.LIST_INSTANCE_OPINOMETROS, listaInstanceOpinometro));
    } catch (error) {
        yield put(instanceOpinometroApiResponseError(InstanceOpinometroActionTypes.LIST_INSTANCE_OPINOMETROS, error));
    }
}

export function* watchGetInstanceOpinometro(): any {
    yield takeEvery(InstanceOpinometroActionTypes.GET_INSTANCE_OPINOMETRO, getInstanceOpinometro);
}

export function* watchListInstanceOpinometro(): any {
    yield takeEvery(InstanceOpinometroActionTypes.LIST_INSTANCE_OPINOMETROS, listInstanceOpinometro);
}

export function* watchAddInstanceOpinometro(): any {
    yield takeEvery(InstanceOpinometroActionTypes.ADD_INSTANCE_OPINOMETRO, addInstanceOpinometro)
}
export function* watchUpdateInstanceOpinometro(): any {
    yield takeEvery(InstanceOpinometroActionTypes.UPDATE_INSTANCE_OPINOMETRO, updateInstanceOpinometro)
}
export function* watchDeleteInstanceOpinometro(): any {
    yield takeEvery(InstanceOpinometroActionTypes.DELETE_INSTANCE_OPINOMETRO, deleteInstanceOpinometro)
}

function* instanceOpinometroSaga(): any {
    yield all([
        fork(watchGetInstanceOpinometro),
        fork(watchListInstanceOpinometro),
        fork(watchAddInstanceOpinometro),
        fork(watchUpdateInstanceOpinometro),
        fork(watchDeleteInstanceOpinometro)
    ]);
}

export default instanceOpinometroSaga;
